import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

const FunctionalityPage = ({ data, onUpdate }) => {
  const [selectedFeatures, setSelectedFeatures] = useState(data.selectedFeatures || []);
  const [fieldErrors, setFieldErrors] = useState({
    selectedFeatures: ''
  });
  const [isAlwaysIncludedExpanded, setIsAlwaysIncludedExpanded] = useState(false);

  // Update parent component when data changes
  useEffect(() => {
    onUpdate({
      selectedFeatures
    });
  }, [selectedFeatures]);

  // Define all available features
  const features = [
    {
      id: 'bank-integration',
      title: 'Direct bank integration',
      description: 'Connect directly with your bank for secure payments and real-time transaction data'
    },
    {
      id: 'payroll',
      title: 'Payroll',
      description: 'Manage payments to your employees'
    },
    {
      id: 'electronic-invoicing',
      title: 'Electronic invoicing',
      description: 'Create and send electronic invoices'
    },
    {
      id: 'invoice-processing',
      title: 'Incoming invoice processing',
      description: 'Automatically receive and process incoming invoices'
    },
    {
      id: 'digital-signing-id-card',
      title: 'Signing with ID card',
      description: 'Sign payments with your ID card'
    },
    {
      id: 'digital-signing-smart-id',
      title: 'Signing with Smart-ID',
      description: 'Authenticate and sign payments with Smart-ID'
    },
    // {
    //   id: 'scheduled-tasks',
    //   title: 'Scheduled Tasks',
    //   description: 'Automate repetitive tasks and workflows'
    // },
    // {
    //   id: 'data-migration',
    //   title: 'Data Migration',
    //   description: 'Migrate data from your existing systems'
    // },
    // {
    //   id: 'custom-development',
    //   title: 'Custom Development',
    //   description: 'Tailored solutions for specific business needs'
    // },
    // {
    //   id: 'customizations',
    //   title: 'System Customizations',
    //   description: 'Customize CashManager to match your workflow'
    // },
    // {
    //   id: 'user-training',
    //   title: 'User Training',
    //   description: 'Comprehensive training for your team'
    // },
    // {
    //   id: 'support-maintenance',
    //   title: 'Support & Maintenance',
    //   description: 'Ongoing technical support and system maintenance'
    // }
  ];

  // Handle feature selection
  const handleFeatureToggle = (featureId) => {
    setSelectedFeatures(prev => {
      if (prev.includes(featureId)) {
        return prev.filter(id => id !== featureId);
      } else {
        return [...prev, featureId];
      }
    });

    // Clear validation error when user makes a selection
    setFieldErrors(prev => ({
      ...prev,
      selectedFeatures: ''
    }));
  };

  // Handle always included section toggle
  const toggleAlwaysIncluded = () => {
    setIsAlwaysIncludedExpanded(prev => !prev);
  };


  return (
    <div className="wizard-page functionality-page">
      <div className="page-header">
        <h2>Which CashManager additional features interest you most?</h2>
        <p>You can always add more features later. <button
          type="button"
          className="always-included-toggle"
          onClick={toggleAlwaysIncluded}
        >
          {isAlwaysIncludedExpanded ? 'Hide' : 'See'} what's always included
        </button></p>
        {isAlwaysIncludedExpanded && (
        <div className="always-included-section">
          <ul className="always-included-list">
            <li>Accounts Receivable (Customer invoicing)</li>
            <li>Accounts Payable (Payments to suppliers)</li>
            <li>Automatic bank reconciliation</li>
            <li>Bank integration via file import/export</li>
            <li>Scheduled tasks</li>
            <li>User rights management</li>
          </ul>
        </div>
      )}

      </div>

      <div className="form-content" id="functionality-form">
        <div className="form-group">
          <div className="features-grid">
            {features.map(feature => (
              <div key={feature.id} className="feature-option">
                <input
                  type="checkbox"
                  id={feature.id}
                  name="features"
                  value={feature.id}
                  checked={selectedFeatures.includes(feature.id)}
                  onChange={() => handleFeatureToggle(feature.id)}
                  className="feature-checkbox"
                />
                <label htmlFor={feature.id} className="feature-label">
                  <div className="feature-checkbox-visual"></div>
                  <div className="feature-content">
                    <div className="feature-title">{feature.title}</div>
                    <div className="feature-description">{feature.description}</div>
                  </div>
                </label>
              </div>
            ))}
          </div>

          {fieldErrors.selectedFeatures && (
            <span className="field-error">{fieldErrors.selectedFeatures}</span>
          )}
        </div>

      </div>
    </div>
  );
};

FunctionalityPage.propTypes = {
  data: PropTypes.shape({
    selectedFeatures: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  onUpdate: PropTypes.func.isRequired
};

export default FunctionalityPage;
